export const API = "/Umbraco/Api";
export const MembershipAPI = "/Umbraco/Api/Membership";
export const ContentAPI = "/Umbraco/Api/SelfAssessmentTools";
export const FooterAPI = "/Umbraco/Api/Footer";
export const HomeUrl = "/";
export const SATUrl = "/sports-safeguarding-tools/";